// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppSystemWebApiPagingResultModel from '../../model/app-system-web-api-paging-result-model';
import AppSystemWebApiPagingResultDTO from '../dto/app-system-web-api-paging-result-dto';
import dtoSchema from '../schemas/app-system-web-api-paging-result-schema';
import AppSystemWebApiModel from '../../model/app-system-web-api-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AppSystemWebApiPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppSystemWebApiPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AppSystemWebApiModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AppSystemWebApiModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AppSystemWebApiPagingResultDTO>): AppSystemWebApiPagingResultModel;
  static toModel(dto: DeepPartial<AppSystemWebApiPagingResultDTO> | undefined | null): AppSystemWebApiPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AppSystemWebApiPagingResultDTO> | undefined | null): AppSystemWebApiPagingResultModel | undefined {
    return dto ? new AppSystemWebApiPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppSystemWebApiPagingResultModel> | AppSystemWebApiPagingResultModel): AppSystemWebApiPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AppSystemWebApiPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppSystemWebApiPagingResultModel, can not map to AppSystemWebApiPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
